<template>
    <a v-if="$attrs.href" class="btn btn-primary">
        <span>
            <slot/>
        </span>
    </a>
    <button v-else class="btn btn-primary">
        <span>
            <slot/>
        </span>
    </button>
</template>

<script>
    export default {
        name: 'btn',
    };
</script>
